(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gang-sheet-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
    const roots = document.querySelectorAll('.gsb[data-section-id]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const canvas = root.querySelector('[data-canvas]');
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const messages = JSON.parse(root.querySelector('[data-gsb-messages]').textContent);
      const layoutCheck = root.querySelector('[data-layout-check]');
      const rights = root.querySelector('[data-rights]');
      const variant = root.querySelector('[data-variant]');
      const upload = root.querySelector('[data-upload]');
      const duplicateButton = root.querySelector('[data-duplicate]');
      const rotateButton = root.querySelector('[data-rotate]');
      const deleteButton = root.querySelector('[data-delete]');
      const clearButton = root.querySelector('[data-clear]');
      const autoArrangeButton = root.querySelector('[data-auto-arrange]');
      const widthInput = root.querySelector('[data-width]');
      const heightInput = root.querySelector('[data-height]');
      const lockInput = root.querySelector('[data-lock]');
      const addButton = root.querySelector('[data-add]');
      const count = root.querySelector('[data-count]');
      const price = root.querySelector('.gsb__summary [data-price]');
      const dimensions = root.querySelector('[data-dimensions]');
      const status = root.querySelector('[data-status]');
      const sizeChoices = [...root.querySelectorAll('[data-size-choice]')];
      const stepLinks = [...root.querySelectorAll('[data-step-link]')];
      const stepPanels = [...root.querySelectorAll('[data-step-panel]')];
      const backButton = root.querySelector('[data-back]');
      const nextButton = root.querySelector('[data-next]');
      const moreArtworkButton = root.querySelector('[data-more-artwork]');
      const sheetSummary = root.querySelector('[data-sheet-summary]');
      const uploadCount = root.querySelector('[data-upload-count]');
      const selectedName = root.querySelector('[data-selected-name]');
      const checkoutHelp = root.querySelector('[data-checkout-help]');
      const emptyMessage = root.querySelector('[data-empty]');
      let currentStep = 1;
      let isUploading = false;
      const items = [];
      let selected = null;
      let dragging = false;
      let isSubmitting = false;
      let dragOffset = { x: 0, y: 0 };
      const pixelsPerInch = 75;
      const printPixelsPerInch = 300;
      const defaultWidth = 22;

      const parseDimensions = (title) => {
        const match = title.match(/(\d+(?:\.\d+)?)\s*(?:in|inch|\")?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
        if (match) return { width: Number(match[1]), height: Number(match[2]) };
        const heightMatch = title.match(/(\d+(?:\.\d+)?)\s*(?:in|inch|\")/i);
        return { width: defaultWidth, height: heightMatch ? Number(heightMatch[1]) : 24 };
      };

      const itemBox = (item) => {
        const rotated = Math.abs(Math.sin(item.rotation)) > .5;
        const width = rotated ? item.height : item.width;
        const height = rotated ? item.width : item.height;
        return { width, height, left: item.x - width / 2, top: item.y - height / 2, right: item.x + width / 2, bottom: item.y + height / 2 };
      };
      const keepInside = (item) => {
        const box = itemBox(item);
        item.x = box.width <= canvas.width ? Math.max(box.width / 2, Math.min(canvas.width - box.width / 2, item.x)) : canvas.width / 2;
        item.y = box.height <= canvas.height ? Math.max(box.height / 2, Math.min(canvas.height - box.height / 2, item.y)) : canvas.height / 2;
      };
      const layoutProblem = () => {
        const boxes = items.map(itemBox);
        if (boxes.some((box) => box.left < -.01 || box.top < -.01 || box.right > canvas.width + .01 || box.bottom > canvas.height + .01)) return messages.outside;
        for (let a = 0; a < boxes.length; a += 1) {
          for (let b = a + 1; b < boxes.length; b += 1) {
            if (boxes[a].left < boxes[b].right - .01 && boxes[a].right > boxes[b].left + .01 && boxes[a].top < boxes[b].bottom - .01 && boxes[a].bottom > boxes[b].top + .01) return messages.overlap;
          }
        }
        return '';
      };
      const setSheetSize = () => {
        const option = variant.options[variant.selectedIndex];
        const size = parseDimensions(option.dataset.title || option.textContent);
        canvas.width = Math.max(300, Math.round(size.width * pixelsPerInch));
        canvas.height = Math.max(300, Math.round(size.height * pixelsPerInch));
        dimensions.textContent = `${size.width}\" × ${size.height}\"`;
        price.textContent = option.dataset.price;
        sheetSummary.textContent = `${size.width} × ${size.height} inches`;
        sizeChoices.forEach((choice) => { choice.checked = choice.value === variant.value; });
        items.forEach(keepInside);
        draw();
      };

      const updateControls = () => {
        const busy = isSubmitting || isUploading;
        const hasSelection = Boolean(selected) && !busy;
        sizeChoices.forEach((choice) => {
          const option = [...variant.options].find((entry) => entry.value === choice.value);
          choice.disabled = busy || option.disabled;
        });
        stepLinks.forEach((link) => {
          const step = Number(link.dataset.stepLink);
          link.disabled = busy || (step === 3 && items.length === 0);
          if (step === currentStep) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
        stepPanels.forEach((panel) => { panel.hidden = Number(panel.dataset.stepPanel) !== currentStep; });
        backButton.hidden = currentStep === 1;
        backButton.disabled = busy;
        nextButton.hidden = currentStep === 3;
        nextButton.disabled = busy || (currentStep === 2 && items.length === 0) || variant.options[variant.selectedIndex].disabled;
        nextButton.textContent = currentStep === 1 ? 'Continue to upload' : 'Continue to size & arrange';
        moreArtworkButton.disabled = busy;
        uploadCount.textContent = isUploading ? 'Loading your artwork…' : (items.length ? `${items.length} ${items.length === 1 ? 'image' : 'images'} on your sheet` : 'No artwork uploaded yet.');
        selectedName.textContent = selected ? selected.file.name : 'No image selected';
        emptyMessage.hidden = items.length > 0;
        checkoutHelp.textContent = currentStep === 1 ? 'Choose your sheet size, then continue to upload.' : currentStep === 2 ? 'Upload artwork, then continue to set your image sizes.' : 'Check each image size and your layout before adding to cart.';
        variant.disabled = busy;
        upload.disabled = busy;
        lockInput.disabled = busy;
        clearButton.disabled = busy || items.length === 0;
        duplicateButton.disabled = !hasSelection;
        rotateButton.disabled = !hasSelection;
        deleteButton.disabled = !hasSelection;
        widthInput.disabled = !hasSelection;
        heightInput.disabled = !hasSelection;
        autoArrangeButton.disabled = busy || items.length === 0 || currentStep !== 3;
        const problem = layoutProblem();
        layoutCheck.textContent = items.length ? (problem || messages.layout_ok) : '';
        layoutCheck.dataset.invalid = String(Boolean(problem));
        rights.disabled = busy;
        addButton.disabled = busy || currentStep !== 3 || items.length === 0 || Boolean(problem) || !rights.checked || variant.options[variant.selectedIndex].disabled;
        root.setAttribute('aria-busy', String(busy));
        count.textContent = `${items.length} ${items.length === 1 ? 'image' : 'images'}`;
        if (selected) {
          widthInput.value = (selected.width / pixelsPerInch).toFixed(2).replace(/\.?0+$/, '');
          heightInput.value = (selected.height / pixelsPerInch).toFixed(2).replace(/\.?0+$/, '');
        } else {
          widthInput.value = '';
          heightInput.value = '';
        }
      };

      const goToStep = (step) => {
        if (isSubmitting || isUploading || (step === 3 && !items.length)) return;
        currentStep = Math.max(1, Math.min(3, step));
        updateControls();
        root.querySelector(`[data-step-panel="${currentStep}"] .gsb__step-title`).focus({ preventScroll: true });
      };
      stepLinks.forEach((link) => link.addEventListener('click', () => goToStep(Number(link.dataset.stepLink))));
      backButton.addEventListener('click', () => goToStep(currentStep - 1));
      nextButton.addEventListener('click', () => goToStep(currentStep + 1));
      moreArtworkButton.addEventListener('click', () => goToStep(2));
      rights.addEventListener('change', updateControls);
      sizeChoices.forEach((choice) => choice.addEventListener('change', () => {
        if (!choice.checked) return;
        variant.value = choice.value;
        setSheetSize();
      }));

      const drawItem = (item) => {
        ctx.save();
        ctx.translate(item.x, item.y);
        ctx.rotate(item.rotation);
        ctx.drawImage(item.image, -item.width / 2, -item.height / 2, item.width, item.height);
        if (item === selected) {
          ctx.strokeStyle = '#ff2f92';
          ctx.lineWidth = 3;
          ctx.setLineDash([8, 5]);
          ctx.strokeRect(-item.width / 2, -item.height / 2, item.width, item.height);
          ctx.setLineDash([]);
          const widthInches = (item.width / pixelsPerInch).toFixed(2).replace(/\.?0+$/, '');
          const heightInches = (item.height / pixelsPerInch).toFixed(2).replace(/\.?0+$/, '');
          const sizeText = `${widthInches}\" W × ${heightInches}\" H`;
          const previewScale = canvas.width / Math.max(1, canvas.getBoundingClientRect().width);
          const fontSize = 15 * previewScale;
          ctx.font = `900 ${fontSize}px Arial, sans-serif`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          const labelWidth = ctx.measureText(sizeText).width + 16 * previewScale;
          const labelHeight = fontSize + 12 * previewScale;
          ctx.fillStyle = 'rgba(0, 0, 0, .78)';
          ctx.fillRect(-labelWidth / 2, -labelHeight / 2, labelWidth, labelHeight);
          ctx.fillStyle = '#fff';
          ctx.fillText(sizeText, 0, 0, Math.max(20, labelWidth - 16));
        }
        ctx.restore();
      };

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        items.forEach(drawItem);
        updateControls();
      };

      const point = (event) => {
        const rect = canvas.getBoundingClientRect();
        const source = event.touches ? event.touches[0] : event;
        return {
          x: (source.clientX - rect.left) * (canvas.width / rect.width),
          y: (source.clientY - rect.top) * (canvas.height / rect.height)
        };
      };

      const hitTest = (p) => {
        for (let index = items.length - 1; index >= 0; index -= 1) {
          const item = items[index];
          const cosine = Math.cos(-item.rotation);
          const sine = Math.sin(-item.rotation);
          const dx = p.x - item.x;
          const dy = p.y - item.y;
          const localX = dx * cosine - dy * sine;
          const localY = dx * sine + dy * cosine;
          if (Math.abs(localX) <= item.width / 2 && Math.abs(localY) <= item.height / 2) return item;
        }
        return null;
      };

      const loadFile = (file, offset) => new Promise((resolve, reject) => {
        if (!/\.(png|jpe?g)$/i.test(file.name) || file.size === 0 || file.size > 20 * 1024 * 1024) { reject(new Error(messages.invalid_file)); return; }
        const image = new Image();
        const objectUrl = URL.createObjectURL(file);
        image.onload = () => {
          URL.revokeObjectURL(objectUrl);
          const targetWidth = Math.min(canvas.width * .32, image.naturalWidth / printPixelsPerInch * pixelsPerInch);
          const ratio = image.naturalHeight / image.naturalWidth;
          const item = {
            image,
            file,
            x: canvas.width / 2 + offset,
            y: canvas.height / 2 + offset,
            width: targetWidth,
            height: targetWidth * ratio,
            rotation: 0
          };
          keepInside(item);
          items.push(item);
          selected = item;
          resolve();
        };
        image.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          reject(new Error('Image could not be loaded'));
        };
        image.src = objectUrl;
      });

      upload.addEventListener('change', async () => {
        const files = Array.from(upload.files || []);
        if (!files.length || isSubmitting || isUploading) return;
        isUploading = true;
        updateControls();
        const results = await Promise.allSettled(files.map((file, index) => loadFile(file, index * 12)));
        isUploading = false;
        upload.value = '';
        const failed = results.filter((result) => result.status === 'rejected').length;
        status.textContent = failed ? `${failed}: ${messages.invalid_file}` : '';
        draw();
      });

      variant.addEventListener('change', setSheetSize);
      const setExactSize = (changed) => {
        if (!selected) return;
        const oldRatio = selected.height / selected.width;
        const requestedWidth = Number(widthInput.value);
        const requestedHeight = Number(heightInput.value);
        const requested = changed === 'width' ? requestedWidth : requestedHeight;
        if (!Number.isFinite(requested) || requested < .1) { status.textContent = messages.invalid_size; draw(); return; }
        status.textContent = '';
        if (changed === 'width' && requestedWidth > 0) {
          selected.width = requestedWidth * pixelsPerInch;
          if (lockInput.checked) selected.height = selected.width * oldRatio;
        }
        if (changed === 'height' && requestedHeight > 0) {
          selected.height = requestedHeight * pixelsPerInch;
          if (lockInput.checked) selected.width = selected.height / oldRatio;
        }
        keepInside(selected);
        draw();
      };
      widthInput.addEventListener('change', () => setExactSize('width'));
      heightInput.addEventListener('change', () => setExactSize('height'));

      const packItems = (ordered) => {
        const gap = pixelsPerInch * .15;
        let spaces = [{ x: gap, y: gap, width: canvas.width - gap, height: canvas.height - gap }];
        const placements = [];
        for (const item of ordered) {
          let best = null;
          spaces.forEach((space) => {
            for (const turn of [0, 1]) {
              const rotation = item.rotation + turn * Math.PI / 2;
              const box = itemBox({ ...item, rotation });
              const width = box.width + gap;
              const height = box.height + gap;
              if (width > space.width + .001 || height > space.height + .001) continue;
              const score = Math.min(space.width - width, space.height - height);
              const waste = space.width * space.height - width * height;
              if (!best || score < best.score || (score === best.score && waste < best.waste)) best = { x: space.x, y: space.y, width, height, rotation, score, waste, item };
            }
          });
          if (!best) return null;
          const next = [];
          for (const space of spaces) {
            const right = space.x + space.width;
            const bottom = space.y + space.height;
            const placedRight = best.x + best.width;
            const placedBottom = best.y + best.height;
            if (best.x >= right || placedRight <= space.x || best.y >= bottom || placedBottom <= space.y) { next.push(space); continue; }
            if (best.x > space.x) next.push({ ...space, width: best.x - space.x });
            if (placedRight < right) next.push({ ...space, x: placedRight, width: right - placedRight });
            if (best.y > space.y) next.push({ ...space, height: best.y - space.y });
            if (placedBottom < bottom) next.push({ ...space, y: placedBottom, height: bottom - placedBottom });
          }
          spaces = next.filter((space, index) => space.width > .001 && space.height > .001 && !next.some((other, otherIndex) => otherIndex !== index && other.x <= space.x && other.y <= space.y && other.x + other.width >= space.x + space.width && other.y + other.height >= space.y + space.height && (otherIndex < index || other.width * other.height > space.width * space.height)));
          placements.push({ item, x: best.x + (best.width - gap) / 2, y: best.y + (best.height - gap) / 2, rotation: best.rotation });
        }
        return placements;
      };
      autoArrangeButton.addEventListener('click', () => {
        const byArea = [...items].sort((a, b) => b.width * b.height - a.width * a.height);
        const bySide = [...items].sort((a, b) => Math.max(b.width, b.height) - Math.max(a.width, a.height));
        const packed = packItems(byArea) || packItems(bySide);
        if (!packed) { status.textContent = messages.cannot_fit; return; }
        packed.forEach(({ item, x, y, rotation }) => Object.assign(item, { x, y, rotation }));
        status.textContent = messages.arranged;
        draw();
      });

      duplicateButton.addEventListener('click', () => {
        if (!selected) return;
        const copy = { ...selected, x: selected.x + 18, y: selected.y + 18 };
        items.push(copy);
        selected = copy;
        draw();
      });
      rotateButton.addEventListener('click', () => {
        if (!selected) return;
        selected.rotation += Math.PI / 2;
        keepInside(selected);
        draw();
      });
      deleteButton.addEventListener('click', () => {
        if (!selected) return;
        items.splice(items.indexOf(selected), 1);
        selected = null;
        draw();
      });
      clearButton.addEventListener('click', () => {
        items.length = 0;
        selected = null;
        draw();
      });

      const startDrag = (event) => {
        if (isSubmitting || isUploading) return;
        const p = point(event);
        selected = hitTest(p);
        dragging = Boolean(selected);
        if (selected) {
          dragOffset = { x: p.x - selected.x, y: p.y - selected.y };
          event.preventDefault();
        }
        draw();
      };
      const moveDrag = (event) => {
        if (isSubmitting || isUploading || !dragging || !selected) return;
        const p = point(event);
        selected.x = Math.max(0, Math.min(canvas.width, p.x - dragOffset.x));
        selected.y = Math.max(0, Math.min(canvas.height, p.y - dragOffset.y));
        keepInside(selected);
        event.preventDefault();
        draw();
      };
      const endDrag = () => { dragging = false; };
      canvas.addEventListener('mousedown', startDrag);
      canvas.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
      canvas.addEventListener('touchstart', startDrag, { passive: false });
      canvas.addEventListener('touchmove', moveDrag, { passive: false });
      window.addEventListener('touchend', endDrag);

      const setPngResolution = async (blob) => {
        const bytes = new Uint8Array(await blob.arrayBuffer());
        const view = new DataView(bytes.buffer);
        const signature = [137, 80, 78, 71, 13, 10, 26, 10];
        if (!signature.every((value, index) => bytes[index] === value)) {
          throw new Error('The print export is not a PNG');
        }
        const physical = new Uint8Array(21);
        const physicalView = new DataView(physical.buffer);
        physicalView.setUint32(0, 9);
        physical.set([112, 72, 89, 115], 4);
        const pixelsPerMetre = Math.round(printPixelsPerInch / 0.0254);
        physicalView.setUint32(8, pixelsPerMetre);
        physicalView.setUint32(12, pixelsPerMetre);
        physical[16] = 1;
        let crc = 0xffffffff;
        for (const byte of physical.subarray(4, 17)) {
          crc ^= byte;
          for (let bit = 0; bit < 8; bit += 1) {
            crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
          }
        }
        physicalView.setUint32(17, (crc ^ 0xffffffff) >>> 0);
        const parts = [bytes.subarray(0, 8)];
        let inserted = false;
        let ended = false;
        for (let offset = 8; offset + 12 <= bytes.length;) {
          const length = view.getUint32(offset);
          const end = offset + length + 12;
          if (end > bytes.length) throw new Error('Incomplete PNG export');
          const type = String.fromCharCode(...bytes.subarray(offset + 4, offset + 8));
          if (type !== 'pHYs') parts.push(bytes.subarray(offset, end));
          if (type === 'IHDR' && !inserted) {
            parts.push(physical);
            inserted = true;
          }
          offset = end;
          if (type === 'IEND') {
            ended = true;
            break;
          }
        }
        if (!inserted || !ended) throw new Error('Incomplete PNG export');
        return new Blob(parts, { type: 'image/png' });
      };

      const createPrintExport = async (size) => {
        const printCanvas = document.createElement('canvas');
        try {
          printCanvas.width = Math.round(size.width * printPixelsPerInch);
          printCanvas.height = Math.round(size.height * printPixelsPerInch);
          const printContext = printCanvas.getContext('2d');
          if (!printContext) throw new Error(messages.export_failed);
          printContext.fillStyle = '#fff';
          printContext.fillRect(0, 0, printCanvas.width, printCanvas.height);
          printContext.scale(printPixelsPerInch / pixelsPerInch, printPixelsPerInch / pixelsPerInch);
          printContext.imageSmoothingEnabled = true;
          printContext.imageSmoothingQuality = 'high';
          items.forEach((item) => {
            printContext.save();
            printContext.translate(item.x, item.y);
            printContext.rotate(item.rotation);
            printContext.drawImage(item.image, -item.width / 2, -item.height / 2, item.width, item.height);
            printContext.restore();
          });
          const blob = await new Promise((resolve) => printCanvas.toBlob(resolve, 'image/png'));
          if (!blob) throw new Error(messages.export_failed);
          if (blob.size > 20 * 1024 * 1024) throw new Error(messages.export_large);
          return await setPngResolution(blob);
        } finally {
          printCanvas.width = 0;
          printCanvas.height = 0;
        }
      };

      addButton.addEventListener('click', async () => {
        if (!items.length || isSubmitting || isUploading || currentStep !== 3 || !rights.checked || layoutProblem() || variant.options[variant.selectedIndex].disabled) return;
        isSubmitting = true;
        dragging = false;
        const previousSelection = selected;
        const option = variant.options[variant.selectedIndex];
        const variantId = variant.value;
        const size = parseDimensions(option.dataset.title || option.textContent);
        status.textContent = 'Preparing your gang sheet…';
        selected = null;
        draw();
        try {
          const blob = await createPrintExport(size);
          const form = new FormData();
          form.append('id', variantId);
          form.append('quantity', '1');
          form.append('properties[Sheet size]', `${size.width} x ${size.height} inches`);
          form.append('properties[Design count]', String(items.length));
          form.append('properties[_print_dpi]', String(printPixelsPerInch));
          form.append('properties[_mirror_for_sublimation]', 'yes');
          form.append('properties[Gang sheet artwork]', blob, `gang-sheet-${Date.now()}.png`);
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', body: form });
          if (!response.ok) throw new Error(messages.cart_failed);
          const added = await response.json();
          const artwork = added.properties && added.properties['Gang sheet artwork'];
          if (typeof artwork !== 'string' || !/^(https:\/\/|\/)/.test(artwork)) {
            if (!added.key) throw new Error(messages.cleanup_failed);
            const cleanup = await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: added.key, quantity: 0 }) });
            if (!cleanup.ok) throw new Error(messages.cleanup_failed);
            throw new Error(messages.missing_artwork);
          }
          window.location.href = `${window.Shopify.routes.root}cart`;
        } catch (error) {
          status.textContent = Object.values(messages).includes(error.message) ? error.message : messages.cart_failed;
          isSubmitting = false;
          selected = previousSelection;
          draw();
        }
      });

      setSheetSize();
    });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
